// The message to show when signing in fails. The server explains refusals such
// as a deactivated account ("Your account has been deactivated…") or a number
// that isn't a store admin; showing that instead of a blanket "Invalid OTP"
// tells the person what actually went wrong.
export const loginErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (error?.response) return 'Invalid OTP';
  return 'Could not reach the server. Check your connection and try again.';
};
